import RespinWinResult from "model/respin-win-result";
import scatterResultBuilder from "quickfire/integration/builders/result/scatter-result-builder";
import Record from "slotworks/model/gameplay/records/record";
import FreespinWinResult from "slotworks/model/gameplay/records/results/freespin-win-result";
import Result from "slotworks/model/gameplay/records/results/result";
import { ResultBuilder } from "slotworks/server/builders/result-builder";

class SGScatterResultBuilder implements ResultBuilder {
    public filter(win: QuickfireWin): boolean {
        return parseInt(win.attributes.payline) === -1 && !win.attributes.ways;
    }

    public build(record: Record, win: QuickfireWin, packet: QuickfireResponsePacket): Result[] {
        let results = scatterResultBuilder.build(record, win, packet);

        if (results.length > 1 && results[1] instanceof FreespinWinResult) {
            const freespinWinResult = results[1] as FreespinWinResult;
            const tokens = packet.Response.Tokens.Token as QuickfireToken[];
            for (const token of tokens) {
                if (token.attributes.name === "FreeSpinsAwarded") {
                    freespinWinResult.freespinsWon = parseInt(token.attributes.value);
                }
            }
        }

        if (win.attributes.reason === "FS1Trigger") {
            const respinWinResult = new RespinWinResult();
            results = [respinWinResult];
        }

        return results;
    }
}

export default new SGScatterResultBuilder();
